import { Point } from "appworks/utils/geom/point";
import { gamevyModel } from "gamevy/gamevy-model";
import { slotDefinition } from "slotworks/model/slot-definition";
import { SymbolDefinition } from "slotworks/model/symbol-definition";

export function convertGamevyPatternToLine(pattern: boolean[][]): Point[] {
    const toReturn: Point[] = [];

    pattern.forEach((reel, reelIndex: number) => {
        reel.forEach((value: boolean, row: number) => {
            if (value) {
                toReturn.push(new Point(reelIndex, row));
            }
        });
    });

    return toReturn;

}

export function convertGamevyGridToSlotworksGrid(reels: Array<Array<number | string>>): string[][] {
    const grid = reels.map((reel) => {
        return reel.map((serverID) => {
            return getSymbolNameFromServerID(serverID);
        });
    });

    return grid;
}

export function getSymbolIndexFromServerID(serverid: number | string) {
    return gamevyModel.symbolMap.get(serverid);
}

export function getSymbolDefinitionFromServerID(serverid: number | string): SymbolDefinition {
    const symbolIndex = getSymbolIndexFromServerID(serverid);

    return slotDefinition.symbolDefinitions[symbolIndex];
}

export function getSymbolNameFromServerID(serverid: number | string): string {
    const def = getSymbolDefinitionFromServerID(serverid);
    if (def) {
        return def.id;
    } else {
        return null;
    }
}
